export default function StudyInJapanPage() {
  const handleSubmit = (e) => {
    e.preventDefault();
    const form = new FormData(e.currentTarget);
    const payload = Object.fromEntries(form.entries());
    console.log("Inquiry submitted:", payload);
    // TODO: Replace with your submit logic (fetch to Apps Script / backend)
    alert("Thanks! We\'ll contact you soon.");
    e.currentTarget.reset();
  };

  const InquiryForm = ({ variant = "card" }) => (
    <form onSubmit={handleSubmit} className={`w-full ${variant === "card" ? "bg-white/80 backdrop-blur border shadow-sm rounded-2xl p-5 sm:p-6" : "bg-slate-900/90 text-white rounded-2xl p-5 sm:p-6"}`}>
      <h3 className={`text-lg sm:text-xl font-semibold ${variant === "card" ? "text-slate-900" : "text-white"}`}>Book Free Counselling & Guidance</h3>
      <p className={`mt-1 text-sm ${variant === "card" ? "text-slate-600" : "text-slate-200"}`}>Fill this quick form and our team will reach out within 24 hours.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4">
        <div className="flex flex-col">
          <label className="text-sm text-slate-600" htmlFor="name">Name*</label>
          <input required name="name" id="name" className="mt-1 rounded-xl border px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500" placeholder="Your full name" />
        </div>
        <div className="flex flex-col">
          <label className="text-sm text-slate-600" htmlFor="phone">Phone*</label>
          <input required name="phone" id="phone" pattern="[0-9\-\+\s]{7,}" className="mt-1 rounded-xl border px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500" placeholder="e.g. +91 98xxxxxx" />
        </div>
        <div className="flex flex-col">
          <label className="text-sm text-slate-600" htmlFor="email">Email*</label>
          <input required type="email" name="email" id="email" className="mt-1 rounded-xl border px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500" placeholder="you@example.com" />
        </div>
        <div className="flex flex-col">
          <label className="text-sm text-slate-600" htmlFor="city">City</label>
          <input name="city" id="city" className="mt-1 rounded-xl border px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500" placeholder="Your city" />
        </div>
        <div className="flex flex-col">
          <label className="text-sm text-slate-600" htmlFor="background">Background</label>
          <select name="background" id="background" className="mt-1 rounded-xl border px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500">
            <option value="Student">Student (12th / UG)</option>
            <option value="Graduate">Recent Graduate</option>
            <option value="Diploma">Diploma Holder</option>
            <option value="Professional">Working Professional</option>
          </select>
        </div>
        <div className="flex flex-col">
          <label className="text-sm text-slate-600" htmlFor="interest">Interested Program</label>
          <select name="interest" id="interest" className="mt-1 rounded-xl border px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500">
            <option>Study & Work in Japan</option>
            <option>Japanese Language Only</option>
            <option>Tech & Engineering Pathway</option>
            <option>Hospitality & Retail Pathway</option>
          </select>
        </div>
        <div className="sm:col-span-2 flex flex-col">
          <label className="text-sm text-slate-600" htmlFor="message">Message</label>
          <textarea name="message" id="message" rows={3} className="mt-1 rounded-xl border px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500" placeholder="Tell us your goals or questions" />
        </div>
        <label className="sm:col-span-2 inline-flex items-center gap-2 text-sm text-slate-600">
          <input name="consent" type="checkbox" className="size-4 rounded border" required />
          I agree to be contacted on phone/WhatsApp & email.
        </label>
      </div>
      <button type="submit" className={`mt-4 w-full rounded-xl px-4 py-3 font-semibold ${variant === "card" ? "bg-blue-600 text-white hover:bg-blue-700" : "bg-white text-slate-900 hover:bg-slate-100"}`}>Submit Inquiry</button>
    </form>
  );

  const Bullet = ({ children }) => (
    <li className="flex items-start gap-2">
      <span className="mt-1 inline-block size-2 rounded-full bg-blue-600" />
      <span className="text-slate-700">{children}</span>
    </li>
  );

  return (
    <main className="min-h-screen bg-gradient-to-b from-slate-50 to-white text-slate-900">
      {/* HERO */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(37,99,235,0.15),transparent_40%),radial-gradient(circle_at_80%_30%,rgba(14,165,233,0.15),transparent_40%)]" />
        <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <p className="inline-block bg-blue-600/10 text-blue-700 font-medium px-3 py-1 rounded-full text-xs">UniThink Education International</p>
              <h1 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight">
                <span className="block">Ready to turn your talent</span>
                <span className="block">into a high-growth career in Japan?</span>
              </h1>
              <p className="mt-4 text-base sm:text-lg text-slate-600 max-w-prose">
                Join our 1-year Study & Work Immersion: master Japanese (N5→N2), earn through part-time roles, and graduate into full-time opportunities in one of the world's most advanced economies.
              </p>
              <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
                <Bullet>Innovation hub • Robotics • Automotive • Clean tech</Bullet>
                <Bullet>Huge demand for skilled talent</Bullet>
                <Bullet>Earn while studying (up to 28 hrs/week)</Bullet>
                <Bullet>Affordable path vs US/UK/Aus</Bullet>
              </ul>
            </div>
            <div className="lg:pl-6">
              <InquiryForm variant="card" />
            </div>
          </div>
        </div>
      </section>

      {/* WHY JAPAN */}
      <section id="why-japan" className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <h2 className="text-2xl sm:text-3xl font-bold">Why Japan?</h2>
        <div className="mt-6 grid md:grid-cols-3 gap-6">
          {[
            {
              title: "Tech & Innovation",
              desc: "Build your career where robotics, automotive, and electronics lead the world.",
            },
            {
              title: "Talent in Demand",
              desc: "A shrinking population means strong hiring across essential industries.",
            },
            {
              title: "Balanced Lifestyle",
              desc: "Competitive salaries, progressive work culture, and safe cities.",
            },
          ].map((c, i) => (
            <div key={i} className="p-5 rounded-2xl border bg-white shadow-sm hover:shadow-md transition shadow-slate-100">
              <h3 className="font-semibold text-lg">{c.title}</h3>
              <p className="mt-2 text-slate-600 text-sm">{c.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* PROGRAM HIGHLIGHTS */}
      <section className="bg-slate-50 border-y">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
          <h2 className="text-2xl sm:text-3xl font-bold">Program Highlights</h2>
          <div className="mt-6 grid md:grid-cols-3 gap-6">
            <div className="p-5 rounded-2xl border bg-white">
              <h3 className="font-semibold">1-Year Immersion</h3>
              <p className="mt-2 text-sm text-slate-600">Language journey from N5 & N4 (India) to N3 & N2 (Japan) with real-world practice.</p>
            </div>
            <div className="p-5 rounded-2xl border bg-white">
              <h3 className="font-semibold">Work While You Study</h3>
              <p className="mt-2 text-sm text-slate-600">Part-time roles (up to 28 hrs/week) to earn income and build experience.</p>
            </div>
            <div className="p-5 rounded-2xl border bg-white">
              <h3 className="font-semibold">Career Pathway</h3>
              <p className="mt-2 text-sm text-slate-600">Placement support for full-time roles in in-demand sectors after completion.</p>
            </div>
          </div>
        </div>
      </section>

      {/* BENEFITS */}
      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <h2 className="text-2xl sm:text-3xl font-bold">Benefits that matter</h2>
        <div className="mt-6 grid lg:grid-cols-2 gap-6">
          <div className="p-5 rounded-2xl border bg-white">
            <h3 className="font-semibold">Financial Advantage</h3>
            <ul className="mt-3 space-y-2 text-sm text-slate-600">
              <li>Affordable compared to US/UK/Aus pathways.</li>
              <li>Earn ₹1–2 Lakh/month during studies via part-time work.</li>
              <li>Target ₹25–35 Lakh/year in eligible full-time roles.</li>
            </ul>
          </div>
          <div className="p-5 rounded-2xl border bg-white">
            <h3 className="font-semibold">Complete Support</h3>
            <ul className="mt-3 space-y-2 text-sm text-slate-600">
              <li>Visa & paperwork guidance.</li>
              <li>Assistance with lodging in Japan.</li>
              <li>1-year insurance coverage for peace of mind.</li>
            </ul>
          </div>
        </div>
      </section>

      {/* PROGRAM CONTENT */}
      <section className="bg-slate-50 border-y">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
          <h2 className="text-2xl sm:text-3xl font-bold">What you'll learn & do</h2>
          <div className="mt-6 grid md:grid-cols-3 gap-6">
            <div className="p-5 rounded-2xl border bg-white">
              <h3 className="font-semibold">Japanese Mastery</h3>
              <p className="mt-2 text-sm text-slate-600">Speak, read, and work-ready proficiency from N5 to N2 with expert mentors.</p>
            </div>
            <div className="p-5 rounded-2xl border bg-white">
              <h3 className="font-semibold">Real Experience</h3>
              <p className="mt-2 text-sm text-slate-600">Part-time roles to build discipline, teamwork, and cultural fluency.</p>
            </div>
            <div className="p-5 rounded-2xl border bg-white">
              <h3 className="font-semibold">Career Launch</h3>
              <p className="mt-2 text-sm text-slate-600">Guided transition into full-time opportunities across high-growth sectors.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="rounded-3xl border bg-white p-6 sm:p-10 flex flex-col lg:flex-row items-start lg:items-center gap-6">
          <div className="flex-1">
            <h2 className="text-2xl sm:text-3xl font-bold">Limited seats. Big outcomes.</h2>
            <p className="mt-2 text-slate-600">Japan has openings waiting for skilled, motivated talent. Let's secure your place.</p>
          </div>
          <a href="#inquiry-bottom" className="rounded-xl bg-blue-600 text-white px-5 py-3 font-semibold hover:bg-blue-700">Apply Now</a>
        </div>
      </section>

      {/* FOOTER FORM */}
      <section id="inquiry-bottom" className="relative">
        <div className="absolute inset-0 bg-gradient-to-tr from-slate-900 via-slate-800 to-blue-900" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
          <InquiryForm variant="dark" />
          <p className="mt-4 text-center text-slate-200 text-sm">Contact: info@unithink.in • +91 9900 911 649 • +91 9910 438 709</p>
        </div>
      </section>
    </main>
  );
}